import { useReveal } from "../../hooks/useReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "Cosa significa consulente finanziario indipendente fee-only?",
    a: "Significa che vengo pagato esclusivamente dal cliente con una parcella trasparente, e non percepisco alcuna provvigione, retrocessione o incentivo da banche, SGR o compagnie. Il mio unico interesse è il tuo risultato.",
  },
  {
    q: "Sono iscritto all'OCF (Albo dei Consulenti Finanziari)?",
    a: "Sì, sono iscritto alla sezione dei Consulenti Finanziari Autonomi dell'Organismo di vigilanza e tenuta dell'albo unico dei Consulenti Finanziari (OCF), come previsto dalla normativa italiana.",
  },
  {
    q: "Qual è il tuo percorso formativo?",
    a: "Dopo una laurea in Economia, ho conseguito un Executive Master in Consulenza e Pianificazione Finanziaria, ho superato l'Esame di Stato per l'iscrizione all'Albo OCF, e ho studiato presso due tra le più importanti società di consulenza finanziaria indipendenti in Italia, collaborando con una di esse prima di mettermi in proprio. La formazione continua è parte integrante del mio lavoro: non smetto mai di studiare mercati, normativa e strumenti.",
  },
  {
    q: "Qual è il patrimonio minimo per lavorare insieme?",
    a: "Non applico una soglia rigida, ma il servizio è disegnato per chi gestisce un patrimonio finanziario superiore a 100.000 €, oltre a immobili e attività imprenditoriali. Per situazioni più semplici suggerisco soluzioni più snelle in fase di colloquio.",
  },
  {
    q: "Come si svolge il primo colloquio?",
    a: "Il primo incontro è gratuito, dura circa 60 minuti, e si tiene in studio nei pressi di Bergamo oppure in videocall. Serve a conoscersi, capire le tue esigenze e valutare insieme se ha senso proseguire.",
  },
  {
    q: "Come viene calcolata la parcella?",
    a: "La parcella è proporzionale al servizio richiesto e alla complessità del patrimonio. Può essere forfettaria annuale, oppure legata al patrimonio in advisory. Tutto viene definito per iscritto prima dell'inizio del rapporto.",
  },
];

export const Faq = () => {
  const r = useReveal();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-navy text-ivory py-20 md:py-28 border-t border-ivory/10"
    >
      <div className="container-editorial grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div ref={r} className="reveal lg:col-span-4 lg:sticky lg:top-32 self-start">
          <p className="overline text-goldSoft mb-6">Domande frequenti</p>
          <h2 data-testid="faq-title" className="display-2 text-ivory">
            Le risposte<br />
            <em className="italic text-goldSoft">prima di sederci</em>.
          </h2>
          <p className="lede text-ivory/70 mt-6 max-w-md">
            Trasparenza totale, anche prima di parlarci. Se hai un dubbio non elencato,
            il modo più veloce per risolverlo è scrivermi.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-ivory/15"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-ivory hover:no-underline py-7 hover:text-goldSoft transition-colors">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ivory/70 text-base md:text-lg leading-relaxed pb-8 max-w-3xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
